import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c74aab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "part-com" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "part-name",
    src: "https://xiamenban.oss-cn-hangzhou.aliyuncs.com/official/zoujinsichuan.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, "SICHUAN TODAY")
], -1))
const _hoisted_3 = { class: "nav-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introduce" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "印象攀枝花"),
  /*#__PURE__*/_createElementVNode("div", { class: "des" }, "攀枝花1965年建市，是全国唯一以花命名的城市。全市行政 区域面积7414平方公里，辖东区、西区、仁和区和米易县、 盐边县，常住人口121.2万.."),
  /*#__PURE__*/_createElementVNode("div", { class: "see-more" }, "查看更多》")
], -1))

import { ref, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'enterSICHUANG',
  setup(__props) {

let currentNav: number = ref(0);
let changeNav = (index: number) => {
  currentNav.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab-item", _unref(currentNav)==index?'active-item':'']),
          onClick: ($event: any) => (_unref(changeNav)(index)),
          key: index
        }, "二级标题", 10, _hoisted_4)
      }), 64))
    ]),
    _hoisted_5
  ]))
}
}

})